import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";


export const generateDeliveryOtp = async (orderId) => {
  try {
    const resp = await http.post(`${URL}/order/otp/${orderId}/generate`);
    return resp;
  } catch (error) {
    console.error("Error generating delivery OTP:", error);
    errorHandler(error);
    throw error;
  }
};

// Verify delivery OTP for an order with payment collection data
export const verifyDeliveryOtp = async (orderId, otp, paymentData = {}) => {
  try {
    const payload = { otp, ...paymentData };
    const resp = await http.post(`${URL}/order/otp/${orderId}/verify`, payload);
    return resp;
  } catch (error) {
    console.error("Error verifying delivery OTP:", error);
    errorHandler(error);
    throw error;
  }
};

// Get order details by ID
export const getOrderById = async (orderId) => {
  try {
    const resp = await http.get(`${URL}/order/${orderId}`);
    return resp;
  } catch (error) {
    console.error("Error fetching order details:", error);
    errorHandler(error);
    throw error;
  }
};

// services/order.service.js - Update to handle payment status
export const createOrders = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/order/${businessId}/create`, payload);
    return resp;
  } catch (error) {
    console.error("Error creating order:", error);
    errorHandler(error);
    throw error; // Important: re-throw the error so calling function knows it failed
  }
};

export const createPaymentOrder = async (businessId, paymentData) => {
  try {
    let resp = await http.post(
      `${URL}/order/${businessId}/create-payment`,
      paymentData,
    );
    return resp;
  } catch (error) {
    console.error("Error creating payment order:", error);
    errorHandler(error);
  }
};

export const verifyPayment = async (businessId, verificationData) => {
  try {
    let resp = await http.post(
      `${URL}/order/${businessId}/verify-payment`,
      verificationData,
    );
    return resp;
  } catch (error) {
    console.error("Error verifying payment:", error);
    errorHandler(error);
  }
};

export const getAllOrders = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/order/${businessId}/all?${queryString}`);
    return resp;
  } catch (error) {
    console.error("Error fetching orders:", error);
    errorHandler(error);
    throw error;
  }
};

export const getAllUserOrders = async (userId, businessId) => {
  try {
    let resp = await http.get(`${URL}/order/${businessId}/${userId}`);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const updateOrder = async (businessId, customerId, orderId, payload) => {
  try {
    const resp = await http.put(
      `${URL}/order/${businessId}/${customerId}/${orderId}`,
      payload,
    );
    return resp;
  } catch (error) {
    console.error("Error updating order:", error);
    errorHandler(error);
    throw error;
  }
};

export const getOrderDetails = async (businessId, orderId) => {
  try {
    const resp = await http.get(
      `${URL}/order/${businessId}/details/${orderId}`,
    );
    return resp;
  } catch (error) {
    console.error("Error fetching order details:", error);
    errorHandler(error);
    throw error;
  }
};
// services/order.service.js - Add these new functions

export const getCustomerFrequentlyPurchased = async (businessId, customerId) => {
  try {
    const resp = await http.get(`${URL}/order/${businessId}/${customerId}/frequently-purchased`);
    return resp;
  } catch (error) {
    console.error("Error fetching frequently purchased products:", error);
    errorHandler(error);
    throw error;
  }
};

export const getCustomerRecentlyPurchased = async (businessId, customerId) => {
  try {
    const resp = await http.get(`${URL}/order/${businessId}/${customerId}/recently-purchased`);
    return resp;
  } catch (error) {
    console.error("Error fetching recently purchased products:", error);
    errorHandler(error);
    throw error;
  }
};